import { DefaultFormFields, FormControl, FormController } from '@insurancemenu/imenu-components-lib/dist/utils/forms';
import { ProposalDomainData } from 'store/modules/proposal/proposalDomainModule';
import { action, computed, makeObservable, observable, runInAction } from 'mobx';
import { AssigneeType } from 'types/groupService';
import { generateProposal, saveGenerateProposalAnswers } from 'api/operations/proposalServiceV3';
import { IStepController } from './iStepController';

export type ProductSortingOption = 'cart-items' | 'a-z' | 'display-order' | 'low-to-high' | 'high-to-low';

interface SecondStepFields extends DefaultFormFields {
  sortingSetting: FormControl<ProductSortingOption>;
}

type SecondFormController = FormController<SecondStepFields>;

export default class SecondStepController extends IStepController {
  private _form = new FormController<SecondStepFields>({
    sortingSetting: new FormControl<ProductSortingOption>('cart-items'),
  });

  get isValid(): boolean {
    return this._form.isFormValid();
  }

  get form(): SecondFormController {
    return this._form;
  }

  public updateFormData(formData: Record<string, string>): void {
    this._form.populateFields(formData);
  }

  async completeStep(domainData: ProposalDomainData, catalogId: string, domainHeaderId: string): Promise<void> {
    const cartId = domainData.cart.id;
    const answers = this._form.getFormDataObject() as Record<string, string>;
    await saveGenerateProposalAnswers(cartId, answers);
    await runInAction(async () => {
      await generateProposal({
        domainId: domainHeaderId,
        catalogId,
        cart: domainData.cart,
        portfolios: domainData.portfolios,
        period: domainData.enrollmentPeriod,
        // Old groups may have null agentOfRecord (AOR was not required when they were created).
        group: {
          ...domainData.group,
          agentOfRecord: domainData.group.agentOfRecord ?? { id: '', name: '', type: AssigneeType.AGENT },
        },
      });
    });
  }

  constructor() {
    super();
    makeObservable<SecondStepController, '_form'>(this, {
      _form: observable,
      isValid: computed,
      form: computed,
      completeStep: action.bound,
    });
  }
}
